export class Voucher {

    public id: string = "0";
    public name: string;
    
    public product_id: string;
    public product_name: string;

    public sponsor_id: string;
    public sponsor_name: string;

    public member_id: string;
    public member_name: string;
    public member_email: string;

    public discount: number;
    public used: boolean;
    public date_sent: Date;
    
    constructor() {}
}


